import { TripMember } from '../../public-api';

export function membersFilter<T extends TripMember>(members: T[], filter: string): T[] {
  return members.filter((response) => {
    const searchString = `${response.name} ${response.email}`.toLowerCase();
    return searchString.toLowerCase().includes(filter.toLowerCase());
  });
}
